import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-6 md:py-10 px-6" data-id="element-208">
      <div className="max-w-3xl mx-auto" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-210">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brown mb-6 text-center" data-id="element-211">
            El Dolor Que Nadie Entiende
          </h2>

          <div className="bg-cream/50 rounded-3xl p-6 md:p-10 border-l-4 border-rose" data-id="element-212">
            <p className="font-sans text-lg text-brown/90 leading-relaxed mb-4" data-id="element-213">
              Llevas meses, quizás años, viviendo en un ciclo cruel de esperanza
              y duelo cada 28 días. Te han dicho que "te relajes", como si el
              deseo de ser madre fuera un interruptor que puedes apagar. Te
              sientes traicionada por tu propia biología y desconectada de tu
              pareja.
            </p>

            <p className="font-sans text-lg text-brown/90 leading-relaxed font-medium" data-id="element-214">
              Lo que nadie te ha explicado en el consultorio médico es que
              podrías estar cargando con duelos no sanados de tus abuelas,
              secretos familiares o un desorden de roles donde estás siendo
              "madre de tus propios padres", no dejando espacio psíquico para un
              bebé real. Tu vientre no está cerrado por defecto; está
              protegiendo una lealtad invisible al dolor de quienes vinieron
              antes que tú.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}